import { getGuid } from '../../common/helpers/getGuid';

export class GuidHelper {
    static getGuid(): string {
        return getGuid();
    }
}